<template>
  <!-- <div class="w-full h-full grid grid-rows-[auto_1fr] overflow-hidden"> -->
  <div class="w-full h-full">
    <div class="absolute top-3 right-2">
      <div class="flex items-center gap-4 bg-white rounded-full px-4 pt-2 pb-1">
        <div class="cursor-pointer hidden" @click="shareRoom">
          <i class="iconify mdi--share-variant-outline text-black"></i>
        </div>

        <!-- <div class="flex items-center gap-1 cursor-pointer">
          <i class="iconify mdi--account-group-outline text-black"></i>
          <div class="bg-red-500 text-white text-sm px-2 rounded-full">99+</div>
        </div> -->
        <div class="cursor-pointer" @click="goBack">
          <i
            v-if="!showBackToHome"
            class="iconify mdi--close-circle-outline text-black"
          ></i>
          <i v-else class="iconify mdi--home text-black"></i>
        </div>
      </div>
    </div>
    <iframe
      :src="`${URL_PREFIX}/${mode}/?uuid=${uuid}&spriteId=${spriteId}`"
      frameborder="0"
      class="w-full h-full"
    />
  </div>
</template>

<script setup lang="ts">
import { copyToClipboard } from "@/modules/common";
import { useMate } from "@/stores/mate";
import { useRouteQuery } from "@vueuse/router";
import { showSuccessToast } from "vant";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";

const URL_PREFIX = import.meta.env.VITE_GAL_GAME_URL;

const mateStore = useMate();
const route = useRoute();
const router = useRouter();
const mode = useRouteQuery<string>("mode", "dream-home");
const uuid = useRouteQuery<string>("uuid", "");
const spriteId = useRouteQuery<number>("spriteId", 0, {
  transform: (value) => Number(value),
});
const { t } = useI18n();

const showBackToHome = computed(() => {
  return (
    !route.meta.showBottomNav &&
    route.meta.landingPage &&
    !route.meta.auth &&
    !route.meta.internal
  );
});

const goBack = () => {
  if (showBackToHome.value) {
    router.push("/");
  } else {
    router.back();
  }
};

const shareRoom = () => {
  copyToClipboard(`${URL_PREFIX}/${mode.value}`);
  showSuccessToast(t("Message.copySuccessful"));
};
</script>

<style scoped>
.status-1,
.status-2 {
  background: #fed500;
}

.status-3 {
  background: #00fe43;
}
</style>
